import { jsxs as d, jsx as a } from "react/jsx-runtime";
import { Anchor as h } from "../../primitives/anchor/anchor.js";
import { Icon as l } from "../icon/icon.js";
import "react";
import { Text as m } from "../text/text.js";
import u from "clsx";
import { e as g, f as b, g as f, h as p, i as y } from "../../virginmediao2-momentum-icons-icons-fas-C-qJ8QLF.js";
import '../../assets/alert.css';const w = "_alert_114la_1", C = "_alert__icon_114la_53", x = "_alert__head_114la_66", k = "_alert_actions_114la_77", z = "_alert__body_114la_89", r = {
  alert: w,
  "alert--background-bright": "_alert--background-bright_114la_21",
  "alert--has-head": "_alert--has-head_114la_30",
  "alert--success": "_alert--success_114la_35",
  "alert--warning": "_alert--warning_114la_41",
  "alert--error": "_alert--error_114la_47",
  alert__icon: C,
  alert__head: x,
  alert_actions: k,
  alert__body: z,
  "visually-hidden": "_visually-hidden_114la_106"
}, N = (t, e) => {
  switch (t) {
    case "error":
      return /* @__PURE__ */ a(
        l,
        {
          icon: e || p,
          size: "md",
          color: "error"
        }
      );
    case "success":
      return /* @__PURE__ */ a(l, { icon: e || f, size: "md", color: "success" });
    case "warning":
      return /* @__PURE__ */ a(
        l,
        {
          icon: e || b,
          size: "md",
          color: "warning"
        }
      );
    default:
      return /* @__PURE__ */ a(l, { icon: e || g, size: "md", color: "info" });
  }
}, q = ({
  title: t,
  variant: e = "warning",
  bright: i,
  className: o,
  children: c,
  customIcon: n,
  actions: s,
  ..._
}) => /* @__PURE__ */ d(
  "div",
  {
    className: u(
      {
        [r.alert]: !0,
        [r["alert--background-bright"]]: !!i,
        [r["alert--has-head"]]: !!t,
        [r["alert--info"]]: e === "info",
        [r["alert--success"]]: e === "success",
        [r["alert--warning"]]: e === "warning",
        [r["alert--error"]]: e === "error"
      },
      o
    ),
    "data-testid": "alert",
    ..._,
    children: [
      /* @__PURE__ */ a("div", { className: r.alert__icon, "data-testid": "alert-icon", children: N(e, n) }),
      t && /* @__PURE__ */ a("div", { className: r.alert__head, "data-testid": "alert-title", children: /* @__PURE__ */ a(m, { as: "h2", size: "T300", weight: "bold", children: t }) }),
      /* @__PURE__ */ a("div", { className: r.alert__body, "data-testid": "alert-body", children: c }),
      s && /* @__PURE__ */ a("div", { className: r.alert_actions, "data-testid": "alert-actions", children: s })
    ]
  }
), B = ({ onClose: t }) => /* @__PURE__ */ a(
  h,
  {
    asChild: !0,
    icon: /* @__PURE__ */ a(l, { icon: y, size: "sm", ratio: 1 }),
    color: "inherit",
    children: /* @__PURE__ */ a("button", { type: "button", onClick: t, children: /* @__PURE__ */ a("span", { className: r["visually-hidden"], children: "Close" }) })
  }
);
export {
  q as Alert,
  B as AlertClose,
  N as getIcon
};
